import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Button, DatePicker, Input } from '../../Atoms';
import { ValidatorForm } from 'react-form-validator-core';

import './profile-form.scss';
import { acceptInvite } from '../../redux/actions/ManagerAction';
import { connect } from 'react-redux';
import useToaster from '../Toaster/useToaster';
import { formatDate } from '../../utils/helper';
import {
  updateUserInfo,
  reset,
  answerProfile,
} from '../../redux/actions/AuthenticationAction';
import QuestionsList from '../../pages/Profile/QuestionList';

const userFreeTypes = ['text', 'textarea', 'date', 'phone', 'number'];
const multiAnswer = ['checkbox'];

const ProfileForm = ({
  acceptInvite,
  details: {
    firstName = '',
    lastName = '',
    email = '',
    token,
    birthDate = '',
    companyAnniversary = '',
    personalEmail = '',
  } = {},
  acceptInviteInfo: { loading, error, success },
  isOnboarding,
  updateUserInfo,
  updateInfo: { loading: userLoading, success: userSuccess, error: userError },
  boardingProcess,
  info,
  getUserSuccess,
  getUserLoading,
  loginLoading,
  reset,
  questions = [],
  answerProfile,
}) => {
  const { toast } = useToaster();
  const [profileQuestions, setProfileQuestions] = useState(questions);
  const history = useHistory();
  const [formData, setFormData] = useState({
    firstName,
    lastName,
    email,
    password: '',
    personalEmail,
    birthDate,
    companyAnniversary,
  });

  const convertIDtoInt = (ids) =>
    ids.map((id) => {
      return typeof id === 'object' ? parseInt(id.id) : parseInt(id);
    });

  const handleSubmit = () => {
    const payload = {
      first_name: formData.firstName,
      last_name: formData.lastName,
      email,
    };

    if (formData.personalEmail) {
      payload.personal_email = formData.personalEmail;
    }

    if (formData.birthDate) {
      payload.dob = formatDate(formData.birthDate);
    }
    if (formData.companyAnniversary) {
      payload.company_anniversary = formatDate(formData.companyAnniversary);
    }
    if (formData.password) {
      payload.password = formData.password;
    }
    if (isOnboarding) {
      payload.token = token;
      acceptInvite(payload);
    } else {
      updateUserInfo(payload);
      const filteredQuestion = profileQuestions.filter((q) => q.answer?.length);
      if (questions.length && filteredQuestion.length) {
        const answers = filteredQuestion.map((q) => {
          const ans = {
            question: q.id,
          };
          if (userFreeTypes.includes(q.question_type)) {
            if (q.question_type === 'date') {
              const ans =
                typeof q.answer[0] === 'object'
                  ? q.answer[0].answer_text
                  : q.answer[0];
              ans.answer = formatDate(ans);
            } else {
              ans.answer =
                typeof q.answer[0] === 'object'
                  ? q.answer[0].answer_text
                  : q.answer[0];
            }
          } else {
            if (multiAnswer.includes(q.question_type)) {
              ans.question_answer_options = convertIDtoInt(q.answer);
            } else {
              ans.question_answer_options = convertIDtoInt([q.answer[0]]);
            }
          }
          return ans;
        });
        answerProfile({ questions: answers });
      }
    }
  };

  useEffect(() => {
    if ((success && getUserSuccess && isOnboarding) || userSuccess) {
      toast({
        text: isOnboarding
          ? 'Your account has been created'
          : 'Your Profile has been updated',
      });
      if (boardingProcess) {
        const path = info && info.role !== 'employee' ? '/invite' : '/complete';
        history.push(path);
      }
    }

    if (error || userError) {
      toast({
        text: error || userError,
        type: 'error',
      });
    }
    reset('updateInfo');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success, error, userSuccess, userError, getUserSuccess]);

  const handleChange = ({ target: { name, value } }) => {
    if (name === 'email') return;
    setFormData({ ...formData, [name]: value });
  };

  const handleClear = () => {
    if (isOnboarding) {
      setFormData({
        firstName: formData.firstName === firstName ? firstName : '',
        lastName: formData.lastName === lastName ? lastName : '',
        email,
        password: '',
        personalEmail: '',
        birthDate: null,
        companyAnniversary: null,
      });
    } else {
      history.push('/');
    }
  };

  let passwordValidators = [];
  let validatorsMessage = [];
  if (isOnboarding) {
    passwordValidators = ['required'];
    validatorsMessage = ['this field is required'];
  }

  const setAnswer = (id, value) => {
    const allQuestions = [...questions];
    const index = questions.findIndex((question) => question.id === id);
    allQuestions[index].answer = multiAnswer.includes(
      allQuestions[index].question_type
    )
      ? value
      : [value];
    setProfileQuestions(allQuestions);
  };

  return (
    <div className="profile-form-wrapper w-100">
      <ValidatorForm onSubmit={handleSubmit} className="form">
        <Input
          title="First Name"
          name="firstName"
          value={formData.firstName}
          formValid={!error}
          onChange={handleChange}
          validators={['required']}
          errorMessages={['this field is required']}
          fullWidth
        />
        <Input
          title="Last Name"
          name="lastName"
          value={formData.lastName}
          formValid={!error}
          onChange={handleChange}
          validators={['required']}
          errorMessages={['this field is required']}
          fullWidth
        />
        <Input
          title="Email"
          name="email"
          value={formData.email}
          formValid
          onChange={handleChange}
          disbaled="disabled"
          fullWidth
        />
        <Input
          title="Password"
          name="password"
          type="password"
          value={formData.password}
          formValid={!error}
          onChange={handleChange}
          validators={passwordValidators}
          errorMessages={validatorsMessage}
          fullWidth
        />
        <div className="divider">
          <div />
        </div>
        <Input
          title="Personal Email"
          name="personalEmail"
          value={formData.personalEmail}
          formValid
          onChange={handleChange}
          validators={['isEmail']}
          errorMessages={['email is not valid']}
          fullWidth
        />
        <DatePicker
          type="date"
          title="Birthdate"
          name="birthDate"
          value={formData.birthDate}
          formValid
          onChange={handleChange}
          style={{ marginBottom: 16 }}
          fullWidth
        />
        <DatePicker
          type="date"
          title="Company Start Date"
          name="companyAnniversary"
          value={formData.companyAnniversary}
          formValid
          onChange={handleChange}
          style={{ marginBottom: 16 }}
          fullWidth
        />
        {questions?.length > 0 && (
          <QuestionsList
            questions={profileQuestions}
            setAnswer={setAnswer}
            setMultipleValue={setAnswer}
          />
        )}
        <div className="action-wrapper">
          {!boardingProcess && (
            <Button
              type="button"
              size="form-md"
              color="white"
              onClick={handleClear}
            >
              CANCEL
            </Button>
          )}
          <Button
            size="form-md"
            color="blue"
            loading={loading || getUserLoading || userLoading || loginLoading}
          >
            {boardingProcess ? 'Continue' : 'Update'}
          </Button>
        </div>
      </ValidatorForm>
    </div>
  );
};

const mapStateToProps = (state) => ({
  acceptInviteInfo: state.manager.acceptInvite,
  updateInfo: state.auth.updateInfo,
  info: state.auth.userInfo.info || {},
  getUserLoading: state.auth.userInfo.loading,
  getUserSuccess: state.auth.userInfo.success,
  loginLoading: state.auth.login.loading,
  profileQuestion: state.auth.profileQuestion,
});

const mapDispatchToProps = (dispatch) => ({
  acceptInvite: (payload) => {
    dispatch(acceptInvite(payload));
  },
  updateUserInfo: (payload) => {
    dispatch(updateUserInfo(payload));
  },
  reset: (block) => {
    dispatch(reset(block));
  },
  answerProfile: (answers) => {
    dispatch(answerProfile(answers));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileForm);
